"use client";
import { ProcessedCourse } from "@/common/course/types";

interface QuickFactsProps {
  course: ProcessedCourse;
  facts?: {
    title?: string;
    description?: string;
  }[];
  title?: string;
  subTitle?: string;
}

export default function QuickFacts({
  course,
  title,
  subTitle,
  facts,
}: QuickFactsProps) {
  return (
    <section id="quick-facts" className="p-8">
      <h2 className="text-center text-4xl font-bold text-gray-800 mb-4">
        {title}
      </h2>
      <p className="text-gray-600 text-center italic mb-6">
        {subTitle?.replace("{subject}", course.subjectEn || "")}
      </p>

      <div className="flex flex-col md:flex-row gap-6 justify-between">
        {facts?.map((fact, index) => (
          <div key={index} className="flex-1 text-center">
            <h3 className="text-3xl font-extrabold text-gray-800 mb-2">
              {fact.title}
            </h3>
            <p className="text-gray-600">{fact.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
